export const HOME = '/dashboard';
export const ONBOARDING = '/survey/onboarding';
export const SIGN_IN = '/signin';

export const RESET_PASSWORD = ({wasSignedIn}: {wasSignedIn: boolean}) =>
  wasSignedIn ? '/signout' : '/signin';
